module.exports = __webpack_public_path__ + "img/autospin_btn.d9c85582.png";